import { useState } from 'react'
import { Field, Input, Message, Modal, toast } from 'ui'
import {
  useInvalidateChargeLimits,
  useUpdateSpendLimitMutation,
} from 'queries/payment'
import { DollarSignIcon } from 'lucide-react'

interface Props {
  open: boolean
  onClose: () => void
}

export function SpendLimitModal(props: Props) {
  const { open, onClose } = props
  const [limit, setLimit] = useState('')
  const [error, setError] = useState('')
  const { invalidate: invalidateChargeLimits } = useInvalidateChargeLimits()
  const { mutate: updateLimit, isPending: isSaving } =
    useUpdateSpendLimitMutation({
      onSuccess: () => {
        toast.success(`You've successfully set up your monthly spend limit.`)
        invalidateChargeLimits()
        resetForm()
      },
      onError: (err) => {
        setError(err.message)
      },
    })

  const resetForm = () => {
    setLimit('')
    setError('')
    onClose()
  }

  const handleSubmit = () => {
    const limitAmount = Number(limit)
    if (limitAmount && limitAmount > 0) {
      updateLimit(limitAmount)
    } else {
      setError('Please enter a valid amount')
    }
  }

  return (
    <Modal
      title={'Set Up Monthly Spend Limit'}
      open={open}
      onClose={resetForm}
      loading={isSaving}
      onOk={handleSubmit}
    >
      <Field label={'Enter a Spend Limit'}>
        <Input
          icon={<DollarSignIcon size={14} />}
          type={'number'}
          placeholder={'Enter Spend Limit'}
          value={limit}
          onChange={(e) => setLimit(e.target.value)}
        />
      </Field>
      {error ? <Message variant={'error'}>{error}</Message> : null}
    </Modal>
  )
}
